import { __identifier } from "~/stores/identifier.store";

/**
 * Retourne les totaux des quotas alloués et des espaces utilisés
 * à partir du store des identifiants.
 */
export function useStorageQuotas (): {
	totalAllocatedQuota: ComputedRef<number>;
	totalUsedSpace: ComputedRef<number>;
	} {
	const identifiersStore = __identifier();

	const allocated = computed(() => {
		let totalQuota = 0;
		let totalUsed = 0;

		const identifiersMap = identifiersStore.identifiers;
		if (!(identifiersMap)) return { totalQuota, totalUsed };

		identifiersMap.forEach(list => {
			if (Array.isArray(list)) {
				for (const identifier of list) {
					if (identifier.hasQuota && !identifier.isQuotaUnlimited) {
						totalQuota += identifier.quota ?? 0;
					}
					totalUsed += identifier.spaceUsed ?? 0;
				}
			}
		});

		return { totalQuota, totalUsed };
	});

	const totalAllocatedQuota = computed(() => allocated.value.totalQuota);
	const totalUsedSpace = computed(() => allocated.value.totalUsed);

	return { totalAllocatedQuota, totalUsedSpace };
}
